<student-enrollment-wizard-sprite />


@if (current === "first") {

  <section class="main-section">

    <svg>
      <use xlink:href="#startImage"></use>
    </svg>

    @if(studentEnrolmentSettings?.enrollmentMessageSettings?.startScreenMessage) {
      <p>
        {{studentEnrolmentSettings?.enrollmentMessageSettings?.startScreenMessage}}
      </p>
    } @else {
      <p>
        {{ "studentEnrolmentSettings.enrollmentMessageSettings.startScreenMessage" | translate}}
      </p>
    }

    <button (click)="yes()">
      <span>{{ 'common.yes' | translate }}</span>
    </button>

  </section>

}

@if(isNum()) {

  <section class="mid-section" [formGroup]="form">

    <div class="enrollment-field-wrapper">

      @for(enrollmentField of studentEnrolmentSettings?.enrollmentFields; track enrollmentField; let index=$index) {

        @if (index === current || +current > index) {

          @if(index === current) {
          <div class="open-enrollment-field" #enrollmentOpenField>

<!--            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M11.6705 0.314299C11.8549 0.138368 12.1451 0.138368 12.3295 0.314299L13.9078 1.81981C14.0383 1.94432 14.2279 1.98462 14.3978 1.92396L16.452 1.19056C16.692 1.10486 16.9571 1.22286 17.054 1.4586L17.8835 3.4759C17.9521 3.64275 18.1089 3.75667 18.2888 3.77035L20.4637 3.93588C20.7178 3.95522 20.912 4.17082 20.9046 4.4256L20.8419 6.60589C20.8367 6.78621 20.9336 6.95406 21.0924 7.03973L23.0119 8.07555C23.2363 8.1966 23.3259 8.47251 23.2156 8.70229L22.2715 10.6686C22.1934 10.8312 22.2137 11.0239 22.3238 11.1668L23.6561 12.8938C23.8118 13.0956 23.7815 13.3841 23.5872 13.5492L21.925 14.9615C21.7875 15.0783 21.7276 15.2626 21.7702 15.4379L22.2849 17.5575C22.345 17.8052 22.1999 18.0564 21.9554 18.1282L19.8624 18.7423C19.6893 18.7931 19.5596 18.9371 19.5272 19.1146L19.1353 21.2603C19.0894 21.511 18.8547 21.6815 18.6021 21.6476L16.4403 21.3573C16.2615 21.3333 16.0845 21.4121 15.9827 21.5611L14.7519 23.3618C14.6081 23.5723 14.3243 23.6326 14.1073 23.4988L12.2505 22.3544C12.0969 22.2597 11.9031 22.2597 11.7495 22.3544L9.8927 23.4988C9.67572 23.6326 9.39194 23.5723 9.24811 23.3618L8.01732 21.5611C7.91552 21.4121 7.73846 21.3333 7.55967 21.3573L5.39789 21.6476C5.14526 21.6815 4.91055 21.511 4.86475 21.2603L4.4728 19.1146C4.44038 18.9371 4.31069 18.7931 4.13759 18.7423L2.04463 18.1282C1.80005 18.0564 1.655 17.8052 1.71514 17.5575L2.2298 15.4379C2.27236 15.2626 2.21247 15.0783 2.075 14.9615L0.412757 13.5492C0.218511 13.3841 0.188185 13.0956 0.343873 12.8938L1.67616 11.1668C1.78635 11.0239 1.80661 10.8312 1.72852 10.6686L0.784419 8.70229C0.674093 8.47251 0.763744 8.1966 0.988058 8.07555L2.9076 7.03973C3.06636 6.95406 3.16327 6.78621 3.15808 6.60589L3.09536 4.4256C3.08803 4.17082 3.28215 3.95522 3.53631 3.93588L5.71121 3.77035C5.89108 3.75667 6.04788 3.64275 6.11649 3.4759L6.94599 1.4586C7.04292 1.22286 7.30796 1.10486 7.54801 1.19056L9.6022 1.92396C9.77209 1.98462 9.96167 1.94432 10.0922 1.81981L11.6705 0.314299Z" fill="#2D405D"/>-->
<!--              <path d="M8.8402 16V14.7628L12.1225 11.5451C12.4364 11.2281 12.698 10.9465 12.9073 10.7003C13.1166 10.4541 13.2736 10.2156 13.3782 9.98473C13.4828 9.75391 13.5352 9.50769 13.5352 9.24609C13.5352 8.94756 13.4674 8.69212 13.332 8.47976C13.1966 8.26432 13.0104 8.09813 12.7734 7.98118C12.5365 7.86423 12.2672 7.80575 11.9656 7.80575C11.6547 7.80575 11.3823 7.87038 11.1484 7.99964C10.9145 8.12583 10.733 8.30587 10.6037 8.53977C10.4775 8.77367 10.4144 9.0522 10.4144 9.37536H8.7848C8.7848 8.77521 8.92176 8.25355 9.19567 7.81037C9.46958 7.36719 9.84659 7.02403 10.3267 6.78089C10.8099 6.53776 11.3639 6.41619 11.9886 6.41619C12.6226 6.41619 13.1797 6.53468 13.6598 6.77166C14.1399 7.00864 14.5123 7.33333 14.777 7.74574C15.0447 8.15814 15.1786 8.62902 15.1786 9.15838C15.1786 9.51231 15.1109 9.86009 14.9755 10.2017C14.8401 10.5433 14.6016 10.9219 14.2599 11.3374C13.9214 11.7528 13.4459 12.256 12.8335 12.8469L11.2038 14.5043V14.5689H15.3217V16H8.8402Z" fill="white"/>-->
<!--            </svg>-->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- First path remains unchanged -->
              <path d="M11.6705 0.314299C11.8549 0.138368 12.1451 0.138368 12.3295 0.314299L13.9078 1.81981C14.0383 1.94432 14.2279 1.98462 14.3978 1.92396L16.452 1.19056C16.692 1.10486 16.9571 1.22286 17.054 1.4586L17.8835 3.4759C17.9521 3.64275 18.1089 3.75667 18.2888 3.77035L20.4637 3.93588C20.7178 3.95522 20.912 4.17082 20.9046 4.4256L20.8419 6.60589C20.8367 6.78621 20.9336 6.95406 21.0924 7.03973L23.0119 8.07555C23.2363 8.1966 23.3259 8.47251 23.2156 8.70229L22.2715 10.6686C22.1934 10.8312 22.2137 11.0239 22.3238 11.1668L23.6561 12.8938C23.8118 13.0956 23.7815 13.3841 23.5872 13.5492L21.925 14.9615C21.7875 15.0783 21.7276 15.2626 21.7702 15.4379L22.2849 17.5575C22.345 17.8052 22.1999 18.0564 21.9554 18.1282L19.8624 18.7423C19.6893 18.7931 19.5596 18.9371 19.5272 19.1146L19.1353 21.2603C19.0894 21.511 18.8547 21.6815 18.6021 21.6476L16.4403 21.3573C16.2615 21.3333 16.0845 21.4121 15.9827 21.5611L14.7519 23.3618C14.6081 23.5723 14.3243 23.6326 14.1073 23.4988L12.2505 22.3544C12.0969 22.2597 11.9031 22.2597 11.7495 22.3544L9.8927 23.4988C9.67572 23.6326 9.39194 23.5723 9.24811 23.3618L8.01732 21.5611C7.91552 21.4121 7.73846 21.3333 7.55967 21.3573L5.39789 21.6476C5.14526 21.6815 4.91055 21.511 4.86475 21.2603L4.4728 19.1146C4.44038 18.9371 4.31069 18.7931 4.13759 18.7423L2.04463 18.1282C1.80005 18.0564 1.655 17.8052 1.71514 17.5575L2.2298 15.4379C2.27236 15.2626 2.21247 15.0783 2.075 14.9615L0.412757 13.5492C0.218511 13.3841 0.188185 13.0956 0.343873 12.8938L1.67616 11.1668C1.78635 11.0239 1.80661 10.8312 1.72852 10.6686L0.784419 8.70229C0.674093 8.47251 0.763744 8.1966 0.988058 8.07555L2.9076 7.03973C3.06636 6.95406 3.16327 6.78621 3.15808 6.60589L3.09536 4.4256C3.08803 4.17082 3.28215 3.95522 3.53631 3.93588L5.71121 3.77035C5.89108 3.75667 6.04788 3.64275 6.11649 3.4759L6.94599 1.4586C7.04292 1.22286 7.30796 1.10486 7.54801 1.19056L9.6022 1.92396C9.77209 1.98462 9.96167 1.94432 10.0922 1.81981L11.6705 0.314299Z" fill="#2D405D"/>

              <!-- Dynamic Number -->
              <text x="12" y="16" text-anchor="middle" fill="white" font-size="11px" font-weight="bold">{{ current + 1 }}</text>
            </svg>

            <div class="enrollment-field-container">

              <span class="fieldText">
                {{enrollmentField?.fieldText}}
              </span>

              @if(enrollmentField?.fieldId === 'country') {

<!--                <form [formGroup]="form">-->
                  <mat-form-field class="language-field responsive-mat-form-field" appearance="outline">
                    <mat-select
                      class="language-dropdown"
                      (selectionChange)="onSelectionChange($event)"
                      [formControlName]="enrollmentField?.fieldName"
                    >
                      @for(country of countries; track $index;) {
                        <mat-option [value]="country">
                          <div class="dropdown-option-value">
                            {{ country }}
                          </div>
                        </mat-option>
                      }

                      <mat-select-trigger>
                        <div class="selected-language-value">
                          {{ form.get(enrollmentField?.fieldName)?.value }}
                        </div>
                      </mat-select-trigger>
                    </mat-select>
                  </mat-form-field>


              } @else {

                <input
                  #inputField
                  [attr.type]="inputType(enrollmentField)"
                  [placeholder]="enrollmentField?.placeholderText"
                  [formControlName]="enrollmentField?.fieldName"
                  [ngStyle]="{
                  border: border(enrollmentField),
                  outline: 'none',
                  }"
                  (keyup)="keyup($event)"
                  autofocus

                />

              }

              @if (enrollmentField?.mandatory) {
                @if(isControlInvalid(enrollmentField)) {
                  <label class="error">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_10_1444)">
                        <path d="M5 8.75C7.07107 8.75 8.75 7.07107 8.75 5C8.75 2.92893 7.07107 1.25 5 1.25C2.92893 1.25 1.25 2.92893 1.25 5C1.25 7.07107 2.92893 8.75 5 8.75Z" stroke="#F66311" stroke-miterlimit="10"/>
                        <path d="M5 5.3125V3.125" stroke="#F66311" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 7.1875C5.25888 7.1875 5.46875 6.97763 5.46875 6.71875C5.46875 6.45987 5.25888 6.25 5 6.25C4.74112 6.25 4.53125 6.45987 4.53125 6.71875C4.53125 6.97763 4.74112 7.1875 5 7.1875Z" fill="#F66311"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_10_1444">
                          <rect width="10" height="10" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    {{studentEnrolmentSettings?.enrollmentMessageSettings?.mandatoryFieldMessage || 'This field is mandatory'}}
                  </label>
                }
              }

              @if(enrollmentField?.fieldId === 'email') {
                @if(invalidEmail(enrollmentField)) {
                  <label class="error">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_10_1444)">
                        <path d="M5 8.75C7.07107 8.75 8.75 7.07107 8.75 5C8.75 2.92893 7.07107 1.25 5 1.25C2.92893 1.25 1.25 2.92893 1.25 5C1.25 7.07107 2.92893 8.75 5 8.75Z" stroke="#F66311" stroke-miterlimit="10"/>
                        <path d="M5 5.3125V3.125" stroke="#F66311" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 7.1875C5.25888 7.1875 5.46875 6.97763 5.46875 6.71875C5.46875 6.45987 5.25888 6.25 5 6.25C4.74112 6.25 4.53125 6.45987 4.53125 6.71875C4.53125 6.97763 4.74112 7.1875 5 7.1875Z" fill="#F66311"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_10_1444">
                          <rect width="10" height="10" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    {{'This email is invalid'}}
                  </label>
                }
              }

              @if(enrollmentField?.fieldId === 'phoneNumber') {
                @if(invalidPhone(enrollmentField)) {
                  <label class="error">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_10_1444)">
                        <path d="M5 8.75C7.07107 8.75 8.75 7.07107 8.75 5C8.75 2.92893 7.07107 1.25 5 1.25C2.92893 1.25 1.25 2.92893 1.25 5C1.25 7.07107 2.92893 8.75 5 8.75Z" stroke="#F66311" stroke-miterlimit="10"/>
                        <path d="M5 5.3125V3.125" stroke="#F66311" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 7.1875C5.25888 7.1875 5.46875 6.97763 5.46875 6.71875C5.46875 6.45987 5.25888 6.25 5 6.25C4.74112 6.25 4.53125 6.45987 4.53125 6.71875C4.53125 6.97763 4.74112 7.1875 5 7.1875Z" fill="#F66311"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_10_1444">
                          <rect width="10" height="10" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    {{'Phone number is invalid'}}
                  </label>
                }
              }

            </div>

          </div>
          } @else {

            <div class="closed-enrollment-field" (click)="openClosed(index)">

              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.6705 0.314299C11.8549 0.138368 12.1451 0.138368 12.3295 0.314299L13.9078 1.81981C14.0383 1.94432 14.2279 1.98462 14.3978 1.92396L16.452 1.19056C16.692 1.10486 16.9571 1.22286 17.054 1.4586L17.8835 3.4759C17.9521 3.64275 18.1089 3.75667 18.2888 3.77035L20.4637 3.93588C20.7178 3.95522 20.912 4.17082 20.9046 4.4256L20.8419 6.60589C20.8367 6.78621 20.9336 6.95406 21.0924 7.03973L23.0119 8.07555C23.2363 8.1966 23.3259 8.47251 23.2156 8.70229L22.2715 10.6686C22.1934 10.8312 22.2137 11.0239 22.3238 11.1668L23.6561 12.8938C23.8118 13.0956 23.7815 13.3841 23.5872 13.5492L21.925 14.9615C21.7875 15.0783 21.7276 15.2626 21.7702 15.4379L22.2849 17.5575C22.345 17.8052 22.1999 18.0564 21.9554 18.1282L19.8624 18.7423C19.6893 18.7931 19.5596 18.9371 19.5272 19.1146L19.1353 21.2603C19.0894 21.511 18.8547 21.6815 18.6021 21.6476L16.4403 21.3573C16.2615 21.3333 16.0845 21.4121 15.9827 21.5611L14.7519 23.3618C14.6081 23.5723 14.3243 23.6326 14.1073 23.4988L12.2505 22.3544C12.0969 22.2597 11.9031 22.2597 11.7495 22.3544L9.8927 23.4988C9.67572 23.6326 9.39194 23.5723 9.24811 23.3618L8.01732 21.5611C7.91552 21.4121 7.73846 21.3333 7.55967 21.3573L5.39789 21.6476C5.14526 21.6815 4.91055 21.511 4.86475 21.2603L4.4728 19.1146C4.44038 18.9371 4.31069 18.7931 4.13759 18.7423L2.04463 18.1282C1.80005 18.0564 1.655 17.8052 1.71514 17.5575L2.2298 15.4379C2.27236 15.2626 2.21247 15.0783 2.075 14.9615L0.412757 13.5492C0.218511 13.3841 0.188185 13.0956 0.343873 12.8938L1.67616 11.1668C1.78635 11.0239 1.80661 10.8312 1.72852 10.6686L0.784419 8.70229C0.674093 8.47251 0.763744 8.1966 0.988058 8.07555L2.9076 7.03973C3.06636 6.95406 3.16327 6.78621 3.15808 6.60589L3.09536 4.4256C3.08803 4.17082 3.28215 3.95522 3.53631 3.93588L5.71121 3.77035C5.89108 3.75667 6.04788 3.64275 6.11649 3.4759L6.94599 1.4586C7.04292 1.22286 7.30796 1.10486 7.54801 1.19056L9.6022 1.92396C9.77209 1.98462 9.96167 1.94432 10.0922 1.81981L11.6705 0.314299Z" fill="#19D85A"/>
                <g clip-path="url(#clip0_214_622)">
                  <path d="M9.44165 12.1904L11.4601 14.2088L16.0738 9.59518" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_214_622">
                    <rect width="9.22727" height="9.22727" fill="white" transform="translate(8 7)"/>
                  </clipPath>
                </defs>
              </svg>

              <span>
                {{enrollmentField?.fieldText}}
              </span>

            </div>

          }

        }

      }

    </div>

    <div class="footer">

      @if(+current > 0) {
      <button (click)="previous()">
        {{ 'common.previous' | translate }}
      </button>
      } @else {
        <ng-container><span></span></ng-container>
      }

      @if(current === (studentEnrolmentSettings?.enrollmentFields?.length - 1)) {
      <button (click)="complete()">
        {{ 'common.complete' | translate }}
      </button>
      } @else {
        <button (click)="next()">
          {{ 'common.next' | translate }}
        </button>
      }

    </div>

  </section>

}

@if (current === "last") {

  <section class="end-section" [ngStyle]="{
  'flex-direction': !studentEnrolmentSettings?.enrollmentMessageSettings?.headingMessage && !studentEnrolmentSettings?.enrollmentMessageSettings?.text1 ? 'column' : 'initial'
  }">

    <div class="svg-container">
      <svg width="223" height="223" viewBox="0 0 223 223" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.08">
        <circle cx="111.5" cy="111.5" r="111.5" fill="#19D85A"/>
      </g>
      <g opacity="0.08">
        <circle cx="111.5" cy="111.5" r="81.6561" fill="#19D85A"/>
      </g>
      <path d="M111.585 45.0801C111.769 44.9042 112.06 44.9042 112.244 45.0801L123.275 55.6028C123.406 55.7273 123.596 55.7676 123.765 55.7069L138.123 50.5809C138.363 50.4952 138.628 50.6132 138.725 50.8489L144.523 64.9488C144.592 65.1156 144.748 65.2295 144.928 65.2432L160.13 66.4001C160.384 66.4195 160.578 66.6351 160.571 66.8898L160.132 82.1289C160.127 82.3092 160.224 82.477 160.383 82.5627L173.799 89.8025C174.023 89.9236 174.113 90.1995 174.003 90.4293L167.404 104.172C167.326 104.335 167.346 104.528 167.456 104.671L176.768 116.742C176.924 116.943 176.894 117.232 176.699 117.397L165.081 127.268C164.944 127.385 164.884 127.569 164.927 127.745L168.524 142.559C168.584 142.807 168.439 143.058 168.194 143.13L153.566 147.422C153.392 147.473 153.263 147.617 153.23 147.795L150.491 162.792C150.445 163.042 150.21 163.213 149.958 163.179L134.848 161.15C134.669 161.126 134.492 161.205 134.39 161.354L125.788 173.94C125.644 174.151 125.36 174.211 125.143 174.077L112.165 166.078C112.011 165.983 111.818 165.983 111.664 166.078L98.6859 174.077C98.4689 174.211 98.1851 174.151 98.0413 173.94L89.4387 161.354C89.3369 161.205 89.1599 161.126 88.9811 161.15L73.8714 163.179C73.6187 163.213 73.384 163.042 73.3382 162.792L70.5987 147.795C70.5663 147.617 70.4366 147.473 70.2635 147.422L55.6349 143.13C55.3903 143.058 55.2452 142.807 55.3054 142.559L58.9026 127.745C58.9451 127.569 58.8852 127.385 58.7477 127.268L47.1296 117.397C46.9354 117.232 46.905 116.943 47.0607 116.742L56.3727 104.671C56.4829 104.528 56.5031 104.335 56.425 104.172L49.8263 90.4293C49.7159 90.1995 49.8056 89.9236 50.0299 89.8025L63.4465 82.5627C63.6052 82.477 63.7021 82.3092 63.697 82.1289L63.2586 66.8898C63.2512 66.6351 63.4453 66.4195 63.6995 66.4001L78.9009 65.2432C79.0807 65.2295 79.2375 65.1156 79.3061 64.9488L85.1039 50.8489C85.2008 50.6132 85.4659 50.4952 85.7059 50.5809L100.064 55.7069C100.233 55.7676 100.423 55.7273 100.554 55.6028L111.585 45.0801Z" fill="#19D85A"/>
      <g clip-path="url(#clip0_8_716)">
        <path d="M97.9526 111.295L108.969 122.311L134.148 97.132" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_8_716">
          <rect width="50.3584" height="50.3584" fill="white" transform="translate(90.084 82.9688)"/>
        </clipPath>
      </defs>
    </svg>
    </div>

    <div class="messages-container">
<!--      <h2>You've made it!</h2>-->
      @if(studentEnrolmentSettings?.enrollmentMessageSettings?.headingMessage) {
        <h2>{{studentEnrolmentSettings?.enrollmentMessageSettings?.headingMessage}}</h2>
      }

      <!--      <p>Congratulations, your one-time enrolment process is now completed.-->
<!--        Thank you so much for enrolling, and please enjoy the courses!</p>-->

      @if(studentEnrolmentSettings?.enrollmentMessageSettings?.text1) {
        <p>{{studentEnrolmentSettings?.enrollmentMessageSettings?.text1}}</p>
      }

<!--      <p>{{studentEnrolmentSettings?.enrollmentMessageSettings?.text2}}</p>-->
      <button (click)="close()">
        {{ 'common.close' | translate }}
      </button>
    </div>

  </section>

}
